export const en = {

  // SIDEBAR
  "Dashboard": "Dashboard",
  "Customer": "Customer",
  "Vehicles": "Vehicles",

  "Staff": "Staff",
  "Reports": "Reports",
  "Ads": "Ads",
  "Settings": "Settings",
  "Logout": "Logout",
  "English": "English",
  "Arabic": "Arabic",
  "Users": "Users",
  "List Ads": "List Ads",
  "Categories": "Categories",
  "List Bookings": "List Bookings",


  // CUSTOMERS
  "All Customers": "All Customers",
  "New customer": "New customer",
  "Create pledge": "Create pledge",
  "Create new invoice": "Create new invoice",
  "ID Number": "ID Number",
  "License Number": "License Number",
  "Client type": "Client type",
  "Individual": "Individual",
  "Company": "Company",
  "Upload Files": "Upload Files",
  "License no": "License no",
  "Adress": "Adress",

  // COMMAN
  "Edit": "Edit",
  "Email": "Email",
  "Phone": "Phone",
  "Full Name": "Full Name",
  "Address/City": "Address/City",
  "Generate Report": "Generate Report",
  "Cancel": "Cancel",
  "Save": "Save",
  "Submit": "Submit",
  "Send" : "Send",




  // SETTINGS
  "Theme Color": "Theme Color",
  "Terms and Conditions": "Terms and Conditions",
  "Privacy policy": "Privacy policy",


  // CATEGORUES 
  "New category": "New category",
  "Add category": "Add category",
  "Name": "Name",
  "Edit Category": "Edit Category",

  // +++++++++++++++++++
  //   NOTIFICATION
  // +++++++++++++++++++
  "Notifications": "Notifications",
  "New notification": "New notification",
  "Send Notification": "Send Notification",
  "User phone": "User phone",
  "Title": "Title",
  "Description": "Description",
  "Enter the Description here": "Enter the Description here",
  "Id": "Id",
  "Title": "Title",
  "Description": "Description",
  "User name": "User name",
  "User phone": "User phone",








};

